import type { ClientsDatasetResponse } from "../../../lib/api/types";
import { profileIdsMatch } from "../../../lib/clientProfileId";
import type { MasterProfile } from "../../../types";

export type Client360NavigationState = {
    seedProfile?: MasterProfile;
};

export function readClient360NavigationState(state: unknown): Client360NavigationState {
    if (!state || typeof state !== "object") {
        return {};
    }

    const seedProfile = (state as Client360NavigationState).seedProfile;

    return seedProfile ? { seedProfile } : {};
}

export function buildClient360SeedDataset(profile: MasterProfile): ClientsDatasetResponse {
    return {
        profiles: [profile],
        loyaltyRows: [],
        orderRows: [],
        issues: [],
        lastUpdatedAt: new Date().toISOString(),
    };
}

const PROFILE_CACHE_PREFIX = "crm:client-360-profile:";

export function readCachedClient360Profile(profileId: string): ClientsDatasetResponse | undefined {
    if (profileId === "") {
        return undefined;
    }

    try {
        const raw = sessionStorage.getItem(`${PROFILE_CACHE_PREFIX}${profileId}`);

        if (!raw) {
            return undefined;
        }

        const parsed = JSON.parse(raw) as ClientsDatasetResponse;

        return Array.isArray(parsed.profiles) && parsed.profiles.length > 0 ? parsed : undefined;
    } catch {
        return undefined;
    }
}

export function writeCachedClient360Profile(profileId: string, dataset: ClientsDatasetResponse): void {
    if (profileId === "") {
        return;
    }

    try {
        sessionStorage.setItem(`${PROFILE_CACHE_PREFIX}${profileId}`, JSON.stringify(dataset));
    } catch {
        // Ignore quota errors — cache is optional.
    }
}

export function clearCachedClient360Profile(profileId: string): void {
    if (profileId === "") {
        return;
    }

    try {
        sessionStorage.removeItem(`${PROFILE_CACHE_PREFIX}${profileId}`);
    } catch {
        // Ignore.
    }
}

export function readSeedDatasetForProfile(
    profileId: string,
    seedProfile: MasterProfile | null,
): ClientsDatasetResponse | undefined {
    if (seedProfile && profileIdsMatch(seedProfile.profileId, profileId)) {
        return buildClient360SeedDataset(seedProfile);
    }

    return readCachedClient360Profile(profileId);
}
